import React from 'react'
import { useTranslation } from 'react-i18next'
import { format, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { AbortedHeaderRoot, BestellungBadge, Row, Label, Value } from './index.styled'
import { REASON_CODE_TO_KEY } from '../constants'

const formatShort = (iso) => iso ? format(utcToZonedTime(parseISO(iso), 'Europe/Berlin'), 'dd.MM | HH:mm:ss') : ''

const AbortedHeader = React.memo(({ order }) => {
	const { t, i18n } = useTranslation()
	const rawReason = order?.status?.reason?.trim()
	const reasonCode = order?.status?.reasonCode || (REASON_CODE_TO_KEY[rawReason] ? rawReason : null)
	const codeKey = reasonCode ? REASON_CODE_TO_KEY[reasonCode] : null
	const translatedReason = codeKey && (i18n?.exists ? i18n.exists(codeKey) : true) ? t(codeKey) : null
	const isCustomReason = reasonCode === 'OTHER' && rawReason && !REASON_CODE_TO_KEY[rawReason]
	const reasonText = isCustomReason ? rawReason : (translatedReason || (!reasonCode && rawReason))
	return (
		<>
			<BestellungBadge>{t('Modal.orderAbortInfo.orderAborted')}</BestellungBadge>
			<AbortedHeaderRoot>
				<Row>
					<span>
						<Label>{t('restaurant.aborted.createdAt.label')}:</Label>
						<Value>{formatShort(order?.firstOrderTse?.startTime) || t('restaurant.tse.none')}</Value>
					</span>
					<span>
						<Label>{t('restaurant.aborted.am.label')}:</Label>
						<Value>{formatShort(order?.status?.modifiedDate)}</Value>
					</span>
				</Row>
				<Row className="bold">
					<span>
						{reasonText && <>
							<Label>{t('restaurant.aborted.grund.label')}:</Label>
							<Value>{reasonText}</Value>
						</>}
					</span>
					<span>
						<Label>{t('restaurant.aborted.bestellnummer.label')}:</Label>
						<Value>{order?.orderDayCounter}</Value>
					</span>
				</Row>
			</AbortedHeaderRoot>
		</>
	)
})

AbortedHeader.displayName = 'AbortedHeader'
export default AbortedHeader
